import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(theme => {
  return {
    container: {
      position: 'fixed',
      top: 128,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#fff',
      color: 'white',
      zIndex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      display: 'flex',
      padding: 20,
      height: '100%',
      maxWidth: 1440,
      width: '100%',
    },
    contentMobile: {
      display: 'flex',
      flexDirection: 'column',
      padding: 20,
      height: '100%',
      width: '100%',
      gap: 19,
      overflowY: 'auto',
    },
    containerMenuBtn: {
      width: 44,
      height: 44,
      marginLeft: 20,
    },
    containerBackBtn: {
      width: 44,
      height: 44,
      marginRight: 20,
      transform: 'rotate(180deg)',
    },
    containerRoot: {
      overflowY: 'auto',
      maxWidth: 300,
    },
    blockRoot: {
      display: 'flex',
      alignItems: 'center',
      minHeight: 48,
      cursor: 'pointer',
      padding: '0 5px',
      borderRadius: 4,
    },
    rootTitle: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: '#282a3c',
    },
    rootMobileTitle: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 17,
      lineHeight: '24px',
      color: '#181c32',
      cursor: 'pointer',
    },
    rootMobileSubTitle: {
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: 17,
      lineHeight: '24px',
      color: '#181c32',
      cursor: 'pointer',
    },
    childrenTitle: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      color: '#282a3c',
      cursor: 'pointer',
    },
    containerChildren: {
      overflowY: 'auto',
      width: '100%',
      padding: '0 20px',
    },
    title: {
      fontWeight: 700,
      fontSize: 32,
      color: '#282a3c',
    },
    childrens: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 20,
      marginTop: 20,
    },
    column: {
      flex: 1,
    },
    blockChildren: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px 0',
      gap: 8,
    },
    titleChildren: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: '#282a3c',
      cursor: 'pointer',
    },
    moreItems: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      color: '#22305e',
      cursor: 'pointer',
    },
    containerRootCategory: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
    },
    containerSelectedCategory: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
    },
    containerMobileTitle: {
      width: '100%',
    },
    containerSubCategory: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
    },
  };
});
